import React, { Component } from "react";
import PropTypes from "prop-types";
import { Button } from "arv-reactcomponents";
import { filterInitialLength } from "../../../constants";
import { isDesktop } from "../../../utils";
import OmniAndOtherFilters from "./OmniAndOtherFilters";

class ProductFilterBlock extends Component {
  static preventAction(event) {
    event.preventDefault();
  }
  static selectedCount(eachfilterBy) {
    return eachfilterBy.selectedCount > 0
      ? `(${eachfilterBy.selectedCount})`
      : "";
  }
  constructor(props) {
    super(props);
    this.state = {
      displayName: "",
      showMore: false,
      showLess: false,
    };
    this.onFilterClick = this.onFilterClick.bind(this);
    this.isMoreClassName = this.isMoreClassName.bind(this);
    this.getActiveClass = this.getActiveClass.bind(this);
    this.isMoreClicked = this.isMoreClicked.bind(this);
    this.getActiveWidth = this.getActiveWidth.bind(this);
  }

  onFilterClick(event, eachfilterBy) {
    event.preventDefault();
    this.setState({
      showMore: false,
      showLess: !this.state.showLess,
    });
    if (this.state.displayName === eachfilterBy.displayName) {
      this.setState({
        displayName: "",
      });
    } else {
      this.setState({
        displayName: eachfilterBy.displayName,
      });
    }
  }

  getActiveWidth(eachfilterBy) {
    if (!isDesktop) {
      return null;
    }
    if (
      eachfilterBy.list.length &&
      eachfilterBy.displayName === this.state.displayName &&
      this.state.showMore
    ) {
      const width = Math.ceil(eachfilterBy.list.length / filterInitialLength);
      return `${width * 200 + 25}px`;
    }
    return `${200}px`;
  }

  getActiveClass(eachfilterBy) {
    return (
      (this.props.filterBy &&
        eachfilterBy.displayName === this.state.displayName &&
        "nw-filteropen") ||
      ""
    );
  }

  isMoreClassName(eachfilterBy) {
    return (
      (eachfilterBy.displayName === this.state.displayName &&
        this.state.showMore &&
        isDesktop &&
        "is-active") ||
      ""
    );
  }

  isMoreClicked(param) {
    if (param) {
      this.setState({ showMore: !this.state.showMore });
    } else {
      this.setState({ showMore: false });
    }
  }

  render() {
    const { filterBy, className } = this.props;
    if (!filterBy || !filterBy.length) return null;
    return (
      <form
        name="otherFilters"
        className={`nw-productfilterblock ${className}`}
      >
        <h1 className="nw-productfilterblock-filterheadings">FILTER BY</h1>
        <ul className={`nw-productfilterblock-list ${className}`}>
          {filterBy.map(eachfilterBy => (
            <li
              style={{ width: this.getActiveWidth(eachfilterBy) }}
              className={`nw-productfilterblock-li ${this.isMoreClassName(
                eachfilterBy,
              )} ${this.getActiveClass(eachfilterBy)}`}
              key={eachfilterBy.displayName}
            >
              <Button
                onClick={event => this.onFilterClick(event, eachfilterBy)}
                className={`nwc-btn-secondary nw-productfilterblock-filterbutton ${this.getActiveClass(
                  eachfilterBy,
                )} ${className}`}
                onKeyPress={ProductFilterBlock.preventAction}
              >
                <i
                  className={`icomoon-arrow_right nw-productfilterblock-rightarrow ${this.getActiveClass(
                    eachfilterBy,
                  )}`}
                />
                <span>{eachfilterBy.displayName}</span>
                <span className="nw-productfilterblock-selectedcount">
                  {ProductFilterBlock.selectedCount(eachfilterBy)}
                </span>
              </Button>
              <OmniAndOtherFilters
                eachfilterBy={eachfilterBy}
                isFilterOpen={
                  eachfilterBy.displayName === this.state.displayName
                }
                className={className}
                action={this.isMoreClicked}
                showLess={this.state.showLess}
                filterTitle={eachfilterBy.displayName}
              />
            </li>
          ))}
        </ul>
      </form>
    );
  }
}

ProductFilterBlock.defaultProps = {
  className: "",
};

ProductFilterBlock.propTypes = {
  className: PropTypes.string,
  filterBy: PropTypes.oneOfType([
    PropTypes.shape({}).isRequired,
    PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  ]).isRequired,
};

export default ProductFilterBlock;



// WEBPACK FOOTER //
// ./src/component/ProductFilters/ProductFilterBlock/index.js